import React from 'react';
import { BookOpenIcon, MapIcon, ScissorsIcon, ClipboardCheckIcon, GiftIcon, CheckCircleIcon, XCircleIcon, UserCheckIcon, UserXIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="bg-spiritual-50 py-16 md:py-24" data-id="element-144">
      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-145">
        {/* What You Get */}
        <div className="text-center mb-12" data-id="element-146">
          <span className="text-spiritual-600 font-body text-sm uppercase tracking-widest mb-4 block" data-id="element-147">
            Tu Paquete Completo
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-spiritual-900 leading-tight" data-id="element-148">
            Todo lo que recibes con el{' '}
            <span className="text-spiritual-700" data-id="element-149">Código de Sanación</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-16" data-id="element-150">
          <div className="bg-white border border-spiritual-200 rounded-xl p-6 shadow-sm" data-id="element-151">
            <div className="flex items-start gap-4" data-id="element-152">
              <div className="flex-shrink-0 w-11 h-11 bg-spiritual-700/10 rounded-lg flex items-center justify-center" data-id="element-153">
                <BookOpenIcon className="w-5 h-5 text-spiritual-700" aria-hidden="true" data-id="element-154" />
              </div>
              <div data-id="element-155">
                <h3 className="font-heading font-bold text-spiritual-900 text-lg mb-1" data-id="element-156">
                  eBook Central: Código de Sanación del Árbol
                </h3>
                <p className="text-spiritual-800/70 font-body text-sm leading-relaxed" data-id="element-157">
                  Guía paso a paso para identificar y liberar los patrones de
                  escasez heredados de tu linaje.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border border-spiritual-200 rounded-xl p-6 shadow-sm" data-id="element-158">
            <div className="flex items-start gap-4" data-id="element-159">
              <div className="flex-shrink-0 w-11 h-11 bg-spiritual-700/10 rounded-lg flex items-center justify-center" data-id="element-160">
                <MapIcon className="w-5 h-5 text-spiritual-700" aria-hidden="true" data-id="element-161" />
              </div>
              <div data-id="element-162">
                <h3 className="font-heading font-bold text-spiritual-900 text-lg mb-1" data-id="element-163">
                  El Mapa del Tesoro Familiar
                </h3>
                <p className="text-spiritual-800/70 font-body text-sm leading-relaxed" data-id="element-164">
                  Plantilla para identificar fugas de energía en tu árbol
                  genealógico.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border border-spiritual-200 rounded-xl p-6 shadow-sm" data-id="element-165">
            <div className="flex items-start gap-4" data-id="element-166">
              <div className="flex-shrink-0 w-11 h-11 bg-spiritual-700/10 rounded-lg flex items-center justify-center" data-id="element-167">
                <ScissorsIcon className="w-5 h-5 text-spiritual-700" aria-hidden="true" data-id="element-168" />
              </div>
              <div data-id="element-169">
                <h3 className="font-heading font-bold text-spiritual-900 text-lg mb-1" data-id="element-170">
                  Protocolo de Ritual de Corte
                </h3>
                <p className="text-spiritual-800/70 font-body text-sm leading-relaxed" data-id="element-171">
                  Guion exacto para el acto simbólico de liberación de cargas
                  ancestrales.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border border-spiritual-200 rounded-xl p-6 shadow-sm" data-id="element-172">
            <div className="flex items-start gap-4" data-id="element-173">
              <div className="flex-shrink-0 w-11 h-11 bg-spiritual-700/10 rounded-lg flex items-center justify-center" data-id="element-174">
                <ClipboardCheckIcon className="w-5 h-5 text-spiritual-700" aria-hidden="true" data-id="element-175" />
              </div>
              <div data-id="element-176">
                <h3 className="font-heading font-bold text-spiritual-900 text-lg mb-1" data-id="element-177">
                  Test de Diagnóstico de Escasez
                </h3>
                <p className="text-spiritual-800/70 font-body text-sm leading-relaxed" data-id="element-178">
                  Descubre cuál de los 3 contratos invisibles te está bloqueando
                  financieramente.
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-2 bg-gradient-to-r from-spiritual-700 to-spiritual-800 border border-spiritual-400/20 rounded-xl p-6 shadow-lg" data-id="element-179">
            <div className="flex items-start gap-4" data-id="element-180">
              <div className="flex-shrink-0 w-11 h-11 bg-spiritual-400/20 rounded-lg flex items-center justify-center" data-id="element-181">
                <GiftIcon className="w-5 h-5 text-spiritual-400" aria-hidden="true" data-id="element-182" />
              </div>
              <div data-id="element-183">
                <span className="text-spiritual-400 font-body text-xs uppercase tracking-widest font-bold" data-id="element-184">
                  Bonus Exclusivo
                </span>
                <h3 className="font-heading font-bold text-spiritual-100 text-lg mb-1" data-id="element-185">
                  Guía de 7 Días de Afirmaciones de Linaje Sano
                </h3>
                <p className="text-spiritual-200/80 font-body text-sm leading-relaxed" data-id="element-186">
                  Para reprogramar tu merecimiento y abrir el canal de
                  abundancia día a día.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Who This Is For / Not For */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-187">
          {/* For */}
          <div className="bg-white border border-spiritual-200 rounded-2xl p-6 md:p-8" data-id="element-188">
            <div className="flex items-center gap-3 mb-6" data-id="element-189">
              <UserCheckIcon className="w-6 h-6 text-green-600" aria-hidden="true" data-id="element-190" />
              <h3 className="font-heading font-bold text-spiritual-900 text-xl" data-id="element-191">
                Esto es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" role="list" data-id="element-192">
              <li className="flex items-start gap-3" data-id="element-193">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-194" />
                <span className="text-spiritual-800 font-body text-sm leading-relaxed" data-id="element-195">
                  Eres mujer de 30 a 50 años que es el motor económico de su
                  familia pero vive al límite.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-196">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-197" />
                <span className="text-spiritual-800 font-body text-sm leading-relaxed" data-id="element-198">
                  Profesional que siente que su éxito se detiene siempre en el
                  mismo punto financiero.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-199">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-200" />
                <span className="text-spiritual-800 font-body text-sm leading-relaxed" data-id="element-201">
                  Hija que ve que está repitiendo los mismos patrones de
                  sacrificio de su madre.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-202">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-203" />
                <span className="text-spiritual-800 font-body text-sm leading-relaxed" data-id="element-204">
                  Emprendedora que sabotea sus ventas justo cuando empieza a
                  tener éxito real.
                </span>
              </li>
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-spiritual-900/5 border border-spiritual-200 rounded-2xl p-6 md:p-8" data-id="element-205">
            <div className="flex items-center gap-3 mb-6" data-id="element-206">
              <UserXIcon className="w-6 h-6 text-spiritual-800/50" aria-hidden="true" data-id="element-207" />
              <h3 className="font-heading font-bold text-spiritual-800/70 text-xl" data-id="element-208">
                Esto NO es para ti si...
              </h3>
            </div>
            <ul className="space-y-4" role="list" data-id="element-209">
              <li className="flex items-start gap-3" data-id="element-210">
                <XCircleIcon className="w-5 h-5 text-spiritual-800/30 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-211" />
                <span className="text-spiritual-800/60 font-body text-sm leading-relaxed" data-id="element-212">
                  Buscas una fórmula mágica para ganar dinero sin hacer trabajo
                  interior.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-213">
                <XCircleIcon className="w-5 h-5 text-spiritual-800/30 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-214" />
                <span className="text-spiritual-800/60 font-body text-sm leading-relaxed" data-id="element-215">
                  No crees en la influencia de la psicología transgeneracional.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-216">
                <XCircleIcon className="w-5 h-5 text-spiritual-800/30 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-217" />
                <span className="text-spiritual-800/60 font-body text-sm leading-relaxed" data-id="element-218">
                  Prefieres seguir culpando a la economía externa en lugar de
                  sanar tu propia historia.
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Proof / Believability */}
        <div className="bg-gradient-to-br from-spiritual-800 to-spiritual-900 rounded-2xl p-8 md:p-12 border-gold-glow" data-id="element-219">
          <h3 className="text-xl md:text-2xl font-heading font-bold text-spiritual-100 mb-4 text-center" data-id="element-220">
            Lo que cambia en <span className="text-gold-gradient" data-id="element-221">7 días</span>
          </h3>
          <p className="text-spiritual-200 font-body leading-relaxed text-center max-w-3xl mx-auto" data-id="element-222">
            Al desatar el nudo emocional de la lealtad familiar, tu sistema
            nervioso deja de estar en modo "supervivencia". Esto elimina el
            auto-sabotaje, permitiéndote ver oportunidades de negocio que antes
            ignorabas y permitiendo que el dinero{' '}
            <strong className="text-spiritual-300" data-id="element-223">se quede contigo</strong> en
            lugar de buscar excusas para irse.
          </p>
        </div>
      </div>
    </section>;
}